@switch (type()) {
  @case ('cut') {
    <svg class="size-5 not-expanded:size-4" mib-icon name="video-cut"></svg>
  }
  @case ('decision-point') {
    <svg class="size-5 not-expanded:size-4" mib-icon name="circle-check"></svg>
  }
  @case ('strategy') {
    <svg class="size-5 not-expanded:size-4" mib-icon name="strategy"></svg>
  }
  @case ('quiz') {
    <svg class="size-5 not-expanded:size-4" mib-icon name="sticky-note-check"></svg>
  }
  @case ('takeaways') {
    <svg class="size-5 not-expanded:size-4" mib-icon name="bookmark"></svg>
  }
  @case ('barchart') {
    <svg class="size-5 not-expanded:size-4" mib-icon name="chart-column"></svg>
  }
  @case ('search') {
    <svg class="size-5 not-expanded:size-4" mib-icon name="search"></svg>
  }
}
